import { reactive } from 'vue'

export const menu = reactive({
    items: [
        {
            title: 'Ценообразование',
            to: '/prices',
            icon: 'ti-list',
            name: 'prices',
            active: false
        },
        {
            title: 'Стратегии',
            to: '/strategies',
            icon: 'ti-activity',
            name: 'strategies',
            active: false
        },
        {
            title: 'Заказы',
            to: '/report_v1',
            icon: 'ti-table',
            name: 'report_v1',
            active: false
        },
        {
            title: 'Товары',
            to: '/products',
            icon: 'ti-box',
            name: 'products',
            active: false
        },
        {
            title: 'Магазины',
            to: '/stores',
            icon: 'ti-brand-appgallery',
            name: 'stores',
            active: false
        },
    ],
    update(to){
        let active = to.name
        if(to.meta.active !== undefined && to.meta.active){
            active = to.meta.active
        }
        this.items.filter((item) => item.active).forEach((item) => item.active = false)
        this.items.filter((item) => item.name === active).forEach((item) => item.active = true)
        if(MobileMenu.open){
            MobileMenu.toggle()
        }
    }
})

export const MobileMenu = reactive({
    open: false,

    toggle(){
        this.open = !this.open
    }
})